<template>
  <div class="wrap-box">
    <div class="top-box">
      <div class="content-box">
        <div class="car-info-box card-box card-padding">
          <div class="car-info-item">
            <span>订单编号：</span>
            <span
              class="car-no order-no"
              :class="{
                'color-red': taskDetail.vipCompany === '1',
                'order-svip': isZvVipAndVipCompany,
              }"
            >{{ taskDetail.orderNo || "-" }}</span>
            <div
              class="zv-vip-icon"
              v-if="isShowZvVip"
            >至尊VIP</div>
            <div
              class="zv-vip-icon"
              v-if="isShowBcCustomer"
            >黑钻客户</div>
            <img
              v-if="taskDetail.vipCompany === '1'"
              src="@/assets/img/orderGeneral/vipCompany.png"
              class="vip-icon"
            >
            <div>
              <div
                class="copy-btn"
                @click="copy($event, copyText)"
              >复制</div>
            </div>
          </div>
          <div class="car-info-item">
            <span>任务类型：</span>
            <span class="car-no">{{
              taskDetail.productCategoryName || "-"
            }}</span>
            <span
              class="car-no"
              style="margin-left: 8px"
            >{{
              taskDetail.isAccidentRescue === 1 ? "事故" : "非事故"
            }}</span>
          </div>
          <div class="car-info-item">
            <span>服务项目：</span>
            <div>
              <span class="car-no">{{ taskDetail.productSkuName || "-" }}</span>
              <van-tag
                color="#FFF0EA"
                text-color="#C78062"
                v-if="taskDetail.appointmentTime"
              >{{
                taskDetail.appointmentTime.includes("实时") ? "实时" : "预约"
              }}</van-tag>
              <van-tag
                color="#FFF0EA"
                text-color="#C78062"
                v-if="taskDetail.appOrderPayType"
              >{{ taskDetail.appOrderPayType }}</van-tag>
            </div>
          </div>
          <div class="car-info-item">
            <span>车牌号码：</span>
            <span class="car-no">{{ taskDetail.carNo || "-" }}</span>
            <span
              class="copy-btn"
              @click="copy($event, taskDetail.carNo)"
            >复制</span>
          </div>
          <div class="car-info-item">
            <span>车架号码：</span>
            <span class="car-no">{{ taskDetail.vinNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>免费信息：</span>
            <span class="car-no">{{ rightRemark }}</span>
          </div>
          <div class="car-info-item">
            <span>任务地址：</span>
            <span class="car-no">{{ taskDetail.contactAddress }}</span>
          </div>
          <div class="car-info-item">
            <span>接单时间：</span>
            <span class="car-no">{{ taskDetail.takenTime || "" }}</span>
          </div>
          <div class="car-info-item">
            <span>任务状态：</span>
            <span class="car-no">{{ statusTxt }}</span>
          </div>
          <div class="car-info-item">
            <span>备注：</span>
            <span class="car-no">{{ orderRemark }}</span>
          </div>
        </div>

        <div class="car-info-box card-box card-padding">
          <div class="car-info-item">
            <span>审核状态：</span>
            <span class="car-no">审核退回</span>
          </div>
          <div class="car-info-item">
            <span>审核时间：</span>
            <span
              class="car-no"
              v-if="isAuditReturn"
            >{{
              taskDetail.auditReturnTime || "-"
            }}</span>
            <span
              class="car-no"
              v-else-if="isSettlementReturn"
            >{{
              taskDetail.settleReturnTime || "-"
            }}</span>
          </div>
          <div class="car-info-item">
            <span>审核意见：</span>
            <span
              class="car_red"
              v-if="isAuditReturn"
            >{{
              taskDetail.auditReturnReason || "-"
            }}</span>
            <span
              class="car_red"
              v-else-if="isSettlementReturn"
            >{{
              taskDetail.settleReturnReason || "-"
            }}</span>
          </div>
        </div>

        <!-- 现场情况 -->
        <div class="card-box card-padding">
          <div class="card-title card-title-flex">
            <div class="">
              <span>照片</span>
            </div>
          </div>
          <div class="card-info">
            <span
              class="card-tips card-tips__red"
            >提示：请最晚在{{ lastUploadTime }}前补录照片</span>
          </div>
          <van-divider style="margin: 16px -16px" />
          <!-- <van-button
            type="info"
            size="large"
            @click="toPhoto"
          >去补录</van-button> -->
          <Certificate
            v-if="taskNo"
            :photo-params="photoParams"
          />
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        点击重新提审
      </ClickButton>
    </div>

    <!-- 确认弹窗 -->
    <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ClickButton from '@/components/clickButton.vue';
import Certificate from '../components/certificate.vue';
import { ORDER_STATUS_CODE, paicProductCode } from '@/common/constant';
import {
  getTaskDetail,
  getRightRemark,
  getMediaTemplate
} from '@/common/apiPaic.js';
import { reAudit } from '@/common/apiGeneral.js';
import { handleClipboard } from '@/common/clipboard';
import ConfirmDialog from '@/components/confirmDialog.vue';

export default {
  name: 'GeneralOrderReAudit',
  components: {
    ClickButton,
    Certificate,
    ConfirmDialog
  },
  data() {
    return {
      orderNo: '',
      taskNo: '',
      useTraceCar: 0,
      currentPosition: null,
      taskDetail: {},
      rightRemark: '',
      showDatePicker: false,
      copyText: ''
    };
  },
  computed: {
    lastUploadTime() {
      if (this.taskDetail) {
        let time = null;
        if (this.isAuditReturn) {
          time = this.taskDetail.auditReturnTime;
        } else {
          time = this.taskDetail.settleReturnTime;
        }
        const now = dayjs(time);
        return now.add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '-';
      }
    },
    // 是否审核退回
    isAuditReturn() {
      return this.taskDetail.orderStatus === ORDER_STATUS_CODE.auditReturn;
    },
    // 是否结算退回
    isSettlementReturn() {
      return this.taskDetail.orderStatus === ORDER_STATUS_CODE.settlementReturn;
    },
    // 拖车
    isTrailer() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    statusTxt() {
      const statusTxtList = [
        '救援失败',
        '救援成功',
        '撤销有费',
        '撤销无费',
        '救援放空'
      ];
      const index = this.taskDetail.rescueResult
        ? this.taskDetail.rescueResult
        : 0;
      return statusTxtList[index];
    },
    orderRemark() {
      if (this.taskDetail.appServiceType === 'RESCUE_ACCIDENT_PAIC') {
        return this.taskDetail.orderProviderRemark || '';
      } else {
        return this.taskDetail.rescueResultRemark || '';
      }
    },
    photoParams() {
      return {
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        useTraceCar: this.useTraceCar,
        pictureTypes: []
      };
    },
    // 是否显示至尊vip
    isShowZvVip() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_ZV')
      );
    },
    // 是否显示黑钻客户
    isShowBcCustomer() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_BC')
      );
    },
    // 至尊vip和重点保司
    isZvVipAndVipCompany() {
      return (
        this.taskDetail.vipCompany === '1' &&
        (this.isShowZvVip || this.isShowBcCustomer)
      );
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
      this.getTaskDetail();
    }
  },
  methods: {
    copy(e, txt) {
      handleClipboard(txt, e);
    },
    // 滑动到底
    async sliderCompleted() {
      // 重新提审
      this.reAudit();
    },
    // 跳转照片页面
    async toPhoto() {
      const params = {
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        useTraceCar: this.useTraceCar,
        pictureTypes: []
      };
      const router = {
        name: 'GeneralOrderCertificate',
        query: {
          photoParams: JSON.stringify(params)
        }
      };
      console.log('router: ', router);
      // this.$router.push(router);
    },
    // 页面跳转
    toPage(name) {
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      this.$router.replace(router);
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          if (
            [
              paicProductCode.categoryCode_FL10000002,
              paicProductCode.categoryCode_FL10000003
            ].includes(this.taskDetail.categoryCode)
          ) {
            this.useTraceCar = 1;
          } else {
            this.useTraceCar = 0;
          }
          this.getRightRemark();
          // 获取可复制的服务凭证信息
          this.getMediaTemplate();
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取影像模板
    async getMediaTemplate() {
      const res = await getMediaTemplate({
        orderNo: this.orderNo,
        templateType: 'mainTemplate',
        source: 4
      });
      if (res) {
        const data = res || [];
        const arr = [];
        for (const item of data) {
          if (item.secondary) {
            const arr2 = [];
            for (const item2 of item.secondary) {
              if (item2.requiredNum > 0) {
                arr2.push(item2.typeName);
              }
            }
            if (arr2.length > 0) {
              arr.push(`${item.primaryName}(${arr2.join('、')})`);
            }
          }
        }
        this.copyText = this.taskDetail.orderNo + '\n' + arr.join('、');
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    async reAudit(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const res = await reAudit({
          taskNo: this.taskDetail.taskNo,
          taskStatus: this.taskDetail.taskStatus
        });

        if (res && res.code) {
          if (res.code === '7014') {
            const confirmText = res.message || '';
            this.$refs.confirmDialog.open({
              isCancelDelay: true,
              delaySeconds: 5,
              confirmText,
              cancelButtonText: '关闭',
              showConfirmButton: false,
              confirmCallback: () => {
              }
            });
            return;
          }
        }

        if (!noLoading) {
          this.$toast.clear();
        }
        this.toPage('GeneralOrderExecuted');
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box {
  .top-box {
    overflow-y: auto;

    height: calc(100vh - 72px - 46px);

    background: #f2f3f5;
  }
  .bottom-box {
    height: 72px;
  }
}
.flex-box {
  display: flex;
}
.content-box {
  padding-bottom: 32px;

  .car-info-box {
    padding: 13px 16px 15px;

    background: #ffffff;

    .vip-icon {
      width: 19px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }

    .zv-vip-icon {
      margin-left: 4px;
      margin-top: 2px;
      padding: 0 4px;
      text-align: center;
      letter-spacing: 0;
      color: #ffffff;
      border-radius: 4px;
      background: #f32222;
      font-family: PingFangSC-Regular;
      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
      height: 18px;
      white-space: nowrap;
    }

    .copy-btn {
      width: 32px;
      height: 18px;
      margin-left: 4px;
      padding: 2px 6px;

      text-align: center;
      white-space: nowrap;

      color: #3399ff;
      border: 1px solid #3399ff;
      border-radius: 100px;
      background: #eaf4ff;

      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
    }

    .order-no-item {
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;

      .order-no-item-left {
        display: flex;
        flex-wrap: wrap;
      }

      .car-no {
        margin-right: 8px;
      }

      .order-polymerize {
        padding: 1px 8px;

        text-align: center;
        letter-spacing: -0.31px;

        color: #ffffff;
        border-radius: 9px 9px 9px 0px;
        background: #ff8a59;

        font-family: PingFangSC-Medium;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .car-info-item {
      display: flex;

      letter-spacing: -0.38px;
      word-break: break-all;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      .order-tag {
        margin-left: 4px;
        padding: 0 4px;

        text-align: right;
        letter-spacing: -0.26px;

        color: #d36868;
        border-radius: 1px;
        background: #ffe7e7;

        font-family: PingFangSC-Regular;
        font-size: 10px;
        font-weight: 400;
      }

      .copy-btn {
        color: #3399ff;
      }

      .van-tag {
        margin-left: 8px;
        padding: 1px 4px;
      }

      & + .car-info-item {
        padding-top: 8px;
      }
      .carNo {
        padding: 0;
      }
      .car_red {
        color: #f32222;
      }

      .divider {
        padding: 0 5px 0 10px;

        color: #e3e3e3;
      }
      .txt-btn {
        padding: 0 5px;

        color: #3399ff;

        font-size: 10px;
      }
      span {
        &:first-child {
          flex: 0 0 74px;
        }
        & + span {
          color: #383838;
        }
        &.car-no {
          font-family: PingFangSC-Medium;
          font-weight: 500;

          &.color-red {
            color: #f32222;
          }

          &.order-no {
            flex: 0 0 150px;

            word-break: break-all;
          }
          &.order-svip {
            flex: 0 0 100px;
            word-break: break-all;
          }
        }
      }
      .edit {
        margin: 2px 10px;

        color: #3399ff;
      }
    }
  }

  .card-box {
    margin: 12px 12px 0;

    border-radius: 8px;
    background: #ffffff;

    &.card-padding {
      padding: 16px;
    }

    ::v-deep .card-title,
    .card-title {
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;

      &.card-title-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-title-info {
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon {
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-title-distance {
        letter-spacing: -0.38px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 21px;
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        &.card-tips__red {
          color: #f32222;
        }
      }
      .card-tips__gary {
        color: #787878;

        font-size: 12px;
      }
      .card-tag {
        margin-left: 8px;
        padding: 1px 8px 2px;

        letter-spacing: -0.31px;

        border-radius: 2px;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;

        &.card-tag__red {
          color: #c78062;
          background: #fff0ea;
        }
      }
      .card-text-btn {
        text-align: right;
        letter-spacing: -0.38px;

        color: #3399ff;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
      }
    }

    .address-box {
      margin-top: 12px;
      padding: 16px;

      border-radius: 8px;
      background-color: #eff6f5;
      .address-item {
        display: flex;
        align-items: baseline;

        color: #383838;

        font-size: 14px;
        line-height: 21px;

        & + .address-item {
          margin-top: 12px;
        }

        .address-round {
          flex: 10px 0 0;

          width: 10px;
          height: 10px;
          margin-right: 8px;

          border-radius: 100%;
          &.round-green {
            background-color: #76c16d;
          }
          &.round-red {
            background-color: #ef9164;
          }
        }
        &.address-destination {
          color: #7a7f7f;
        }

        .van-icon {
          margin-left: 8px;

          font-size: 16px;
        }
      }
    }

    .car-remark {
      margin-top: 11px;

      letter-spacing: -0.38px;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
    }

    .card-info {
      margin-top: 10px;

      color: #383838;

      font-size: 15px;
    }
    .card-tips__red {
      color: #f32222;
    }

    ::v-deep .van-checkbox {
      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      .van-checkbox__icon {
        font-size: 16px;
        &.van-checkbox__icon--checked .van-icon {
          border-color: #3399ff;
          background-color: #3399ff;
        }
        .van-icon {
          border: 1px solid rgba(153, 153, 153, 1);
          border-radius: 4px;
        }
      }
    }

    .placeholder-box {
      margin-bottom: 24px;
    }

    .van-button {
      text-align: center;
      letter-spacing: -0.38px;

      color: #ffffff;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info {
        border-color: #3399ff;
        background-color: #3399ff;
      }

      &.van-button--large {
        height: 39px;
      }
    }
  }

  .select-box {
    .select-item {
      padding: 5px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      color: #646464;
      border-radius: 4px;
      background: #e1e7ed;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      &.active {
        color: #ffffff;
        background: #3399ff;
      }
    }
  }
  .collapse {
    border-bottom: 1px solid #e6e6e6;
    .isActive {
      color: #ff8a59;

      font-size: 12px;
    }
    ::v-deep .accidentValue {
      color: #3399ff;
    }
    ::v-deep .van-cell__right-icon {
      color: #3399ff;
    }
    ::v-deep .van-cell {
      padding: 10px 0;
    }
    ::v-deep .van-collapse-item__content {
      padding: 5px 0;
    }
  }
  .collapse:last-child {
    border-bottom: 0;
  }

  .textarea-box,
  ::v-deep .textarea-box {
    padding: 12px;

    letter-spacing: -0.38px;

    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
    background: #ffffff;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    ::v-deep .van-field__control {
      color: #383838;

      &::placeholder {
        color: #c8c8c8;
      }
    }
  }
}
.select-box {
  display: flex;
  flex-wrap: wrap;
  .select-item {
    min-width: 30px;
    margin: 0 10px 10px 0;
    padding: 5px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    color: #646464;
    border-radius: 4px;
    background: #e1e7ed;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.active {
      color: #ffffff;
      background: #3399ff;
    }
  }
}
.card-title-sub {
  // font-weight: 500;
  padding: 10px 0 15px;

  color: #787878;
  border-bottom: 1px solid #e6e6e6;

  font-family: PingFangSC-Medium;
  font-size: 15px;
}

.map-btn {
  margin-left: 20px;
  padding: 2px 8px;

  color: #3399ff;
  border: 1px solid #3399ff;
  border-radius: 20px;

  font-size: 10px;
}
</style>
